import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Button, Checkbox, Dropdown, Image, Menu, Tooltip } from "antd";
import { CaretDownOutlined, CaretUpOutlined, ExclamationCircleOutlined, FileImageOutlined, FileTextOutlined, MoreOutlined, UndoOutlined } from "@ant-design/icons";
import moment from "moment";
import { PropertyHandlers } from "../state/actions";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { FaFileArchive, FaFileCsv, FaFileExcel, FaRegFilePdf } from "react-icons/fa";
import confirm from "antd/lib/modal/confirm";
import { Loading } from "../../Common";
import { EmptyData } from "../../Common/components/EmptyData";
import ContractTypeBadge from "../../Common/components/ContractTypeBadge";
import ResureSign from "../../Assets/Icons/Resure_icon.png";
import { formatBaseName } from "../../Common/utils/extraFunctions";

const TrashCanDocs = ({ offerId, propertyId, handleCancelTransCan, handlePropertyDocs }) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 480 });
  const dispatch = useDispatch();
  let { trash_Docs_Data, trash_Docs_Loading } = useSelector((state) => state.PropertyReducer, shallowEqual);
  const ellispesStyle = {
    maxWidth: "330px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "inline-block",
  };
  const [selectedDocs, setSelectedDocs] = useState([]);

  let unmounted = {
    value: false,
  };
  let source = axios.CancelToken.source();
  useEffect(() => {
    const payload = offerId ? { offerId } : propertyId ? { propertyId } : {};

    if (offerId || propertyId) {
      dispatch(PropertyHandlers.getTrashDocs(payload));
    }

    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    };
  }, []);

  const handleCheckboxChange = (checked, doc) => {
    setSelectedDocs((prev) => {
      if (checked) {
        return [...prev, { id: doc._id, type: doc.fileUrl ? "propertyDoc" : "offerDoc" }];
      } else {
        return prev.filter((d) => d.id !== doc._id);
      }
    });
  };

  const handleDone = () => {
    const payload = {
      isTransaction: false,
      docIds: selectedDocs,
    };

    dispatch(PropertyHandlers.restoreTrashDocs(payload));
    setSelectedDocs([]);
    handleCancelTransCan();
  };
  const handleRestoreDocConfirm = (doc, checkBoxValue) => {
    confirm({
      title: "Are you sure you want to restore these Documents for this transaction?",

      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined style={{ color: "orange" }} />,
      onOk() {
        handleDone();
      },
      onCancel() {},
    });
  };
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    order: "DESC",
  });
  
  let sortedDocs = [...trash_Docs_Data || []];

  if (sortConfig.key && sortConfig.order) {
    sortedDocs.sort((a, b) => {
      const aDate = new Date(a[sortConfig.key]).getTime();
      const bDate = new Date(b[sortConfig.key]).getTime();
      return sortConfig.order === "ASC" ? aDate - bDate : bDate - aDate;
    });
  }
    
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "65vh" }}>
      <div
        style={{
          width: "100%",
          textAlign: "center",
          fontSize: isSmallScreen ? "15px" : "20px",
          fontWeight:"bold",
          color: "#178DFA",
          marginBottom: "10px",
        }}
      >
        Deleted Documents
      </div>
      {trash_Docs_Loading ? (
        <Loading />
      ) : trash_Docs_Data?.length > 0 ? (
        <>
          <div style={{ flex: 1, minHeight: "250px", overflowY: "auto" }}>
            <table className="licenseTable" style={{ width: "100%", borderTop: 0 }}>
              <thead style={{ position: "sticky", top: 0, zIndex: 1, background: "white" }}>
                <tr style={{ position: "sticky", top: 0, zIndex: 2 }}>
                  <th>Files</th>
                  <th style={{ textAlign: "center" }}>
  <div
    style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", gap: "4px" }}
    onClick={() => {
      setSortConfig((prev) => {
        const isSameKey = prev.key === "createdAt";
        const newOrder = isSameKey && prev.order === "DESC" ? "ASC" : "DESC";
        return { key: "createdAt", order: newOrder };
      });
    }}
  >
    Creation Date
    <div style={{ display: "flex", flexDirection: "column", marginLeft: "4px" }}>
      <CaretUpOutlined style={{ fontSize: 10, color: sortConfig.key === "createdAt" && sortConfig.order === "DESC" ? "#FFBF00" : "#ccc" }} />
      <CaretDownOutlined style={{ fontSize: 10, color: sortConfig.key === "createdAt" && sortConfig.order === "ASC" ? "#FFBF00" : "#ccc" }} />
    </div>
  </div>
</th>

<th style={{ textAlign: "center" }}>
  <div
    style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", gap: "4px" }}
    onClick={() => {
      setSortConfig((prev) => {
        const isSameKey = prev.key === "deletedAt";
        const newOrder = isSameKey && prev.order === "DESC" ? "ASC" : "DESC";
        return { key: "deletedAt", order: newOrder };
      });
    }}
  >
    Deletion Date
    <div style={{ display: "flex", flexDirection: "column", marginLeft: "4px" }}>
      <CaretUpOutlined style={{ fontSize: 10, color: sortConfig.key === "deletedAt" && sortConfig.order === "DESC" ? "#FFBF00" : "#ccc" }} />
      <CaretDownOutlined style={{ fontSize: 10, color: sortConfig.key === "deletedAt" && sortConfig.order === "ASC" ? "#FFBF00" : "#ccc" }} />
    </div>
  </div>
</th>

                  <th>Restore</th>
                </tr>
              </thead>

              <tbody>
                {sortedDocs?.map((doc) => (
                  <tr key={doc.id} style={{ borderBottom: "1px solid #ddd" }}>
                    <td
                      style={{
                        fontWeight: "bolder",
                        color: "blue",
                        minWidth: "250px",
                        width: "55%",
                        cursor: "pointer",
                        border: "none",
                      }}
                      // onClick={() => handlePropertyDocs(doc)}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          fontSize: isSmallScreen ? "13px" : "16px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ width: "26px", height: "26px" }}>
                            <>
                              {doc.fileType === "IMAGE" ? (
                                <FileImageOutlined
                                  style={{
                                    color: "#ecd540",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : doc.fileType === "ZIP" ? (
                                <FaFileArchive
                                  style={{
                                    color: "#A0A0A0",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : doc.fileType === "CSV" ? (
                                <FaFileCsv
                                  style={{
                                    color: "#3F9E4D",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : doc.fileType === "EXCEL" ? (
                                <FaFileExcel
                                  style={{
                                    color: "#217346",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : doc.fileType === "PDF" || doc.isPdf || doc.pdfLink ? (
                                <FaRegFilePdf
                                  style={{
                                    color: "red",
                                    marginTop: "5px",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : doc.offerDocument && doc.contractType === "LCAES" ? (
                                <FileTextOutlined
                                  style={{
                                    color: "#74b3ed",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              ) : (
                                <FileTextOutlined
                                  style={{
                                    color: "#74b3ed",
                                    marginRight: "5px",
                                    fontSize: "18px",
                                  }}
                                />
                              )}
                            </>
                          </div>
                          <ContractTypeBadge contractType={doc?.contractType} additionalStyle={{ fontSize: "12px" }} />
                          {doc?.isResureSignDoc && (
                            <Tooltip title="RE-Sure Sign Document">
                              <Image
                                style={{
                                  objectFit: "contain",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  // marginLeft: "5px",
                                  marginRight: "-5px",
                                }}
                                height={40}
                                src={ResureSign}
                                preview={false}
                              ></Image>
                            </Tooltip>
                          )}
                          <span style={ellispesStyle}>
                            <Tooltip title={doc?.updatedName ? doc.updatedName.trim() : formatBaseName(doc)}>
                              <span style={{ color: "blue" }}>{doc?.updatedName ? doc.updatedName.trim() : formatBaseName(doc)}</span>
                            </Tooltip>
                            {doc?.updatedName && (
                              <>
                                <br />
                                <Tooltip title={doc.fileUrl ? doc?.fileName : doc?.documentName}>
                                  <span
                                    style={{
                                      fontSize: isSmallScreen ? "11px" : "13px",
                                      color: "grey",
                                    }}
                                  >
                                    {doc.fileUrl ? doc?.fileName : doc?.documentName}
                                  </span>
                                </Tooltip>
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td
                      style={{
                        color: "black",
                        fontWeight: "500",
                        textAlign: "center",
                        minWidth: "50px",
                        width: "10%",
                        whiteSpace: "pre-wrap",
                        border: "none",
                      }}
                    >
                      <div>{moment(doc.createdAt).format("MM/DD/YYYY")}</div>
                      <div>{moment(doc.createdAt).format("hh:mm A")}</div>
                    </td>
                    <td
                      style={{
                        color: "black",
                        fontWeight: "500",
                        textAlign: "center",
                        minWidth: "50px",
                        width: "10%",
                        whiteSpace: "pre-wrap",
                        border: "none",
                      }}
                    >
                      <div>{moment(doc.deletedAt).format("MM/DD/YYYY")}</div>
                      <div>{moment(doc.deletedAt).format("hh:mm A")}</div>
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        minWidth: "70px",
                        width: "10%",
                        color: "#085191",
                        border: "none",
                      }}
                    >
                      <Checkbox checked={selectedDocs.some((d) => d.id === doc._id)} onChange={(e) => handleCheckboxChange(e.target.checked, doc)} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px", gap: "10px" }}>
              <Button onClick={handleCancelTransCan}>Cancel</Button>
              <Button type="primary" onClick={handleRestoreDocConfirm} disabled={selectedDocs.length === 0}>
                Done
                {/* {selectedDocs.length > 0 && `(${selectedDocs.length})`} */}
              </Button>
            </div>
          }
        </>
      ) : (
        <EmptyData />
      )}
    </div>
  );
};

export default TrashCanDocs;
